import {
  Box,
  Card,
  FormControl,
  Grid,
  useMediaQuery,
} from "@mui/material";
import React, { memo, useContext } from "react";
import { StyledApprovalForm } from "./approvalForm.style";
import HyperLink from "../commonComponents/hyperLink/hyperLink";
import Typography from "component/commonComponents/Typography";
import { ThemeContext } from "styled-components";

interface FormData {
  wbsCode: string;
  recipientEmail: string;
  commentType: string;
  comments: string;
}

interface ApprovalFormProps {
  title?: string;
  handleEditForm?: () => void;
  formData: FormData;
  disableShadow?: boolean;
  vertical?: boolean;
  canEdit?: boolean;
  style?: any;
  locale?: Record<string, any>;
}

const ApprovalForm = (props: ApprovalFormProps) => {
  const { title, formData, handleEditForm, disableShadow, vertical, canEdit, style, locale } = props;
  const { titleStyle, ...wrapperStyle } = style;
  const theme = useContext(ThemeContext);
  const smUp = useMediaQuery(`(min-width:${theme.breakpoints.sm})`);

  return (
    <StyledApprovalForm isTabletView={smUp} disableShadow={disableShadow} {...wrapperStyle}>
      <Grid container>
        <Grid item xs={8}>
          <Typography as="h5" className="heading5" id="lbl-approvalform-title" {...titleStyle}>
            {title}
          </Typography>
        </Grid>

        {canEdit && (
          <Grid item xs={4}>
            <HyperLink
              label={locale?.btnLabel}
              onClick={handleEditForm}
              align="right"
              id="lnk-approvalform-edit"
            />
          </Grid>
        )}
      </Grid>
      <Card className="card-wrap">
        <FormControl className="uptime-approval-form-body">
          <Grid container>
            <Grid item xs={12} sm={!!vertical ? 12 : 6}>
              <Box className="content-box bodyRegular">
                <p className="bodyBold">{locale?.costCenter?.label}</p>
                <p id="lbl-approvalform-wbs_code">{formData.wbsCode}</p>
              </Box>
            </Grid>
            <Grid item xs={12} sm={!!vertical ? 12 : 6}>
              <Box className="content-box bodyRegular">
                <p className="bodyBold required">{locale?.recipientEmail?.label}</p>
                <p className="word-wrap" id="lbl-approvalform-recipient_email">{formData.recipientEmail}</p>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box className="content-box bodyRegular">
                <p className="bodyBold">{locale?.comments?.label}</p>
                <p>{formData.commentType}</p>
                <p className="comment-content" id="lbl-approvalform-conmments">{formData.comments}</p>
              </Box>
            </Grid>
          </Grid>
        </FormControl>
      </Card>
    </StyledApprovalForm>
  );
};

export const defaultProps: ApprovalFormProps = {
  title: 'Approval Form',
  formData: {
    wbsCode: '',
    recipientEmail: '',
    commentType: '',
    comments: '',
  },
  disableShadow: false,
  vertical: false,
  canEdit: true,
  style: {
    titleStyle: {},
  },
  locale: {
    btnLabel: 'Edit Approval Details',
    costCenter: 'Cost Center (WBS code)',
    recipientEmail: "Recipient's Direct Manager Email",
    comments: 'Business Justification Comments',
  },
};
ApprovalForm.defaultProps = defaultProps;

export default memo(ApprovalForm);